module.exports = __webpack_public_path__ + "static/media/point3.b4a876ab.png";